export function SettingsPage() {
  return (
    <div className="page">
      <div className="page-head">
        <div>
          <h2 className="page-title">Einstellungen</h2>
          <p className="page-sub">
            Plattform-Konfiguration über Environment-Variablen in Nhost. Spätere Ausbaustufe:
            UI-Verwaltung mit Audit-Log.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-head">
          <div>
            <div className="card-title">Provider</div>
            <div className="card-sub">Mail- und Formular-Adapter — Umschaltung per ENV ohne Code-Änderung</div>
          </div>
        </div>
        <table className="tbl">
          <thead>
            <tr>
              <th>Schlüssel</th>
              <th>Werte</th>
              <th>Default</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="mono">MAIL_PROVIDER</td>
              <td className="mono">lettermint | bloomreach | console</td>
              <td className="mono">console</td>
            </tr>
            <tr>
              <td className="mono">REVIEW_TOKEN_TTL_DAYS</td>
              <td className="mono">Integer</td>
              <td className="mono">30</td>
            </tr>
            <tr>
              <td className="mono">ANTHROPIC_MODEL</td>
              <td className="mono">String</td>
              <td className="mono">claude-opus-4-7</td>
            </tr>
            <tr>
              <td className="mono">REVIEW_LINK_BASE_URL</td>
              <td className="mono">URL</td>
              <td className="mono">—</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
